<div [formGroup]="searchForm">
<mat-card-header>
  <mat-card-title>送付先検索</mat-card-title>
  <mat-icon></mat-icon>
</mat-card-header>
<mat-card-content>
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
      <mat-label>支払契約番号</mat-label>
      <input matInput
        formControlName="claimCtrNo"
        autocomplete="off" />
    </mat-form-field>
    <mat-card-actions class="btn_area_left">
      <button type="submit" mat-raised-button
        color="primary"
        class="btn btnClaimCtrNoSearch"
        style="margin-top:15px;margin-left:25px"
        [disabled]="searchForm.contains('claimCtrNo') === false || searchForm.get('claimCtrNo').value === '' || !searchForm.get('claimCtrNo').valid"
        (click)="clickClaimCtrNoSearch()"
      >検索</button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_left">
      <button type="submit"
        mat-raised-button
        color="primary"
        class="btn btnClaimCtrNoClear"
        style="margin-top:15px;margin-left:25px"
        (click)="clickClaimCtrNoClear()"
      >クリア</button>
    </mat-card-actions>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
      <mat-label>供給地点特定番号</mat-label>
      <input matInput
        formControlName="suppntSpno"
        autocomplete="off"
        (change)="onChangeSuppntSpno()" />
    </mat-form-field>
    <mat-card-actions class="btn_area_left">
      <button type="submit" mat-raised-button
        color="primary"
        class="btn btnSuppntSpnoSearch"
        style="margin-top:15px;margin-left:25px"
        [disabled]="searchForm.contains('suppntSpno') === false || searchForm.get('suppntSpno').value === '' || !searchForm.get('suppntSpno').valid"
        (click)="clickSuppntSpnoSearch()"
      >検索</button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_left">
      <button type="submit" mat-raised-button
        color="primary"
        class="btn btnSuppntSpnoClear"
        style="margin-top:15px;margin-left:25px"
        (click)="clickSuppntSpnoClear()"
      >クリア</button>
    </mat-card-actions>
    <mat-form-field appearance="fill" class="input-form" fxFlex="15" fxFlex.lt-md="15">
      <mat-label>商品種別</mat-label>
      <input matInput
        formControlName="goodsClsfy"
        class="font-color-display-only"
        readonly
      />
    </mat-form-field>
  </div>
</mat-card-content>
</div>